import { ISearchVehiclesResponse } from "../defa-find-engine-heater/actions/search-vehicles";

export interface IGroupedSearchVehiclesResults {
    Grouped: IFindEngineHeaterGroupedResults[];
    Ids: string[];
}

export interface IFindEngineHeaterGroupedResults {
    make: string;
    model: string;
    ehengheater: string;
    ehmountkit: string;
    specs: string[];
}

export function groupSearchVehiclesResults(results: ISearchVehiclesResponse): IGroupedSearchVehiclesResults {
    const grouped = results.Vehicles?.reduce((acc, vehicle) => {
        const key = `${vehicle.ehengheater}-${vehicle.ehmountkit}`;
        const spec = `${vehicle.specs || 'Unknown'}, ${vehicle.modyear || 'Unknown Year'}`;

        if (!acc[key]) {
            acc[key] = {
                make: vehicle.make || 'Unknown',
                model: vehicle.model || 'Unknown',
                ehengheater: vehicle.ehengheater || '',
                ehmountkit: vehicle.ehmountkit || '',
                specs: [ spec ]
            };
        } else {
            acc[key].specs.push(spec);
        }
        return acc;
    }, {} as Record<string, IFindEngineHeaterGroupedResults>);

    const groupedVehiclesByEngineHeater = grouped ? Object.values(grouped) : [];
    const ids = [
        groupedVehiclesByEngineHeater[0]?.ehengheater,
        groupedVehiclesByEngineHeater[0]?.ehmountkit
    ].filter(Boolean) || [];

    return {
        Grouped: groupedVehiclesByEngineHeater,
        Ids: ids
    };
}